<template>
  <div class="justify-content-center text-left dp02 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>

      <b-button type="submit"
                class="myButton"
                @click="$router.push({ name: 'admin.customers.edit', params: { id:id } });"
                style="float:right">
        {{ $t('common.Edit') }}
      </b-button>
    </div>
    <div v-if="!ready"
         class="row mt-5">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span>{{ $t('DataTable.Loading') }}...</span>
    </div>
    <div v-else
         class="row col-lg-12 mt-5">
      <div class="col-12">
        <h2>{{ name }} {{ surname }}</h2>
      </div>
      <div class="col-4">
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.street') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="address.street" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.streetNumber') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="address.streetNumber" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.city') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="address.city" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.zipCode') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="address.zipCode" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.name') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="name" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.surname') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="surname" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.gender') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              :value="$t(gender.value === 2 ? 'common.Male' : 'common.Female')" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.extID') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="extID" />
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.openLimsID') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="openLimsID" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.phone') }}:</label>
          </div>
          <div class="col-lg-9">
            <PhoneNumberInput
              :editable="false"
              v-model="phone" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.email') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="email" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('routes.Reservations') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-textarea
              v-model="reservationStatus"
              class="myInput"
              no-resize
              :disabled="true"
              rows="2" />
          </div>
        </div>
        <div class="row my-3 p-2"
             v-if="DNASampleUsageStatus !== 0">
          <div class="row">
            <div class="col-lg-9">
              <label for="gender">{{ $t('common.DNAAgreement') }}:</label>
            </div>
            <div class="col-lg-9">
              <DNAAgreementDigitalInput
                v-model="DNAAgreementDigital"
                :editable="false" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12">
              <b-form-group :label="$t('common.DNAAgreementDecision')+':'">
                <b-form-radio-group v-model="DNASampleUsageStatus"
                                    name="DNAStatusRadio">
                  <b-form-radio
                    :value="1"
                    :disabled="true">
                    {{ $t('DNAAgreement.1') }}
                  </b-form-radio>
                  <b-form-radio
                    :value="2"
                    :disabled="true">
                    {{ $t('DNAAgreement.2') }}
                  </b-form-radio>
                  <b-form-radio
                    :value="3"
                    :disabled="true">
                    {{ $t('DNAAgreement.3') }}
                  </b-form-radio>
                  <b-form-radio
                    :value="4"
                    :disabled="true">
                    {{ $t('DNAAgreement.4') }}
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-1">
              <b-form-checkbox
                :disabled="true"
                v-model="agreedToSampleBeingUsedForScientificPurposesComputed" />
            </div>
            <div class="col-lg-11 text-left">
              <label for="gender">{{ $t('fields.agreedToSampleBeingUsedForScientificPurposes') }}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-1">
              <b-form-checkbox
                :disabled="true"
                v-model="agreedToSampleExaminationComputed" />
            </div>
            <div class="col-lg-10 text-left">
              <label for="gender">{{ $t('fields.agreedToSampleExamination') }}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-1">
            <b-form-checkbox
              :disabled="true"
              v-model="agreedToDataProcessingComputed" />
          </div>
          <div class="col-lg-10 text-left">
            <label for="gender">{{ $t('fields.agreedToDataProcessing') }}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-1">
            <b-form-checkbox
              :disabled="true"
              v-model="agreedToTermsOfServiceComputed" />
          </div>
          <div class="col-lg-10 text-left">
            <label for="gender">{{ $t('fields.agreedToTermsOfService') }}</label>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="registrationSource">{{ $t('fields.registrationSource') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              :value="$t(registrationSource.value === 1 ? 'common.Client' : (registrationSource.value === 2 ? 'common.Administration' : 'common.Unknown'))" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-1">
            <b-form-checkbox
              :disabled="true"
              v-model="notifyByEmail"
              v-b-tooltip.hover
              :title="$t('notifications.email.ReservationNotificationInfo')" />
          </div>
          <div class="col-lg-4 text-left">
            <label for="notifyByEmail"
                   v-b-tooltip.hover
                   :title="$t('notifications.email.ReservationNotificationInfo')">
              {{ $t('fields.notifyByEmail') }}
            </label>
          </div>
          <div class="col-lg-1">
            <b-form-checkbox
              :disabled="true"
              v-model="notifyBySms"
              v-b-tooltip.hover
              :title="$t('notifications.sms.NearBeforeReservationSmsNotificationInfo')" />
          </div>
          <div class="col-lg-4 text-left">
            <label for="notifyBySms"
                   v-b-tooltip.hover
                   :title="$t('notifications.sms.NearBeforeReservationSmsNotificationInfo')">
              {{ $t('fields.notifyBySms') }}
            </label>
          </div>
        </div>
      </div>

      <div class="col-4 py-2">
        <div class="row px-3">
          <b-button type="submit"
                    class="myButton col-12"
                    @click="downloadAddress()">
            Štítek s adresou
          </b-button>
        </div>
        <div v-if="Object.keys(this.categories).includes('samples')"
             class="row mt-2 px-3">
          <b-button type="submit"
                    class="myButton col-12"
                    @click="$router.push({ name: 'admin.samples.viewdetail', params: { id:categories.samples } });">
            {{ $t('entities.Sample.Singular') }}
          </b-button>
        </div>
        <div v-if="Object.keys(this.categories).includes('products')"
             class="row mt-2 px-3">
          <b-button type="submit"
                    class="myButton col-12"
                    @click="$router.push({ name: 'admin.products.viewdetail', params: { id:categories.products } });">
            {{ $t('entities.Product.Singular') }}
          </b-button>
        </div>
        <div v-if="Object.keys(this.categories).includes('orders')"
             class="row mt-2 px-3">
          <b-button type="submit"
                    class="myButton col-12"
                    @click="$router.push({ name: 'admin.orders.viewdetail', params: { id:categories.orders } });">
            {{ $t('entities.Order.Singular') }}
          </b-button>
        </div>
        <div v-if="Object.keys(this.categories).includes('reservations')"
             class="row mt-2 px-3">
          <b-button type="submit"
                    class="myButton col-12"
                    @click="$router.push({ name: 'admin.customers.reservations.history', params: { id:categories.reservations } });">
            {{ $t('routes.Reservations') }}
          </b-button>
        </div>
        <div class="row mt-2 px-3">
          <b-button type="submit"
                    class="myButton col-12"
                    @click="$router.push({ name: 'admin.questionnaires.viewdetail', params: { id:id } });">
            {{ $t('entities.Questionnaire.Singular') }}
          </b-button>
        </div>
      </div>
      <div class="text-center row col-lg-12 mt-5"
           v-if="audit.length > 0">
        <div class="col-12">
          <h2>{{ $t('common.ChangeLog') }} </h2>
        </div>
        <div class="col-4">
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              class="myInput"
              type="search"
              id="filterInput"
              placeholder="Type to Search" />
            <b-input-group-append>
              <b-button :disabled="!filter"
                        @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="col-12">
          <div class="text-center">
            <b-table
              show-empty
              striped
              borderless
              dark
              hover
              responsive
              :items="audit"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered" />
            <div class="col-2 offset-5">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import DNAAgreementDigitalInput from '@components/input/DNAAgreementDigitalInput';
import PhoneNumberInput from '@components/input/PhoneNumberInput';
import { downloadBlob } from '@utils/downloadBlob';

export default {
  name: 'CustomerViewDetail',
  components: {
    DNAAgreementDigitalInput,
    PhoneNumberInput
  },
  data() {
    return {
      ready: false,
      currentPage: 1,
      perPage: 5,
      filter: '',
      totalRows: 0
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapState('viewCustomer', ['address',
      'gender',
      'email',
      'name',
      'surname',
      'extID',
      'openLimsID',
      'agreedToDataProcessing',
      'agreedToTermsOfService',
      'categories',
      'reservationStatus',
      'DNAAgreementDigital',
      'DNASampleUsageStatus',
      'agreedToSampleBeingUsedForScientificPurposes',
      'agreedToSampleExamination',
      'registrationSource',
      'notifyByEmail',
      'notifyBySms']),
    agreedToDataProcessingComputed: {
      get() {
        return this.agreedToDataProcessing;
      },
      set(val) {
        return val;
      }
    },
    agreedToTermsOfServiceComputed: {
      get() {
        return this.agreedToTermsOfService;
      },
      set(val) {
        return val;
      }
    },
    agreedToSampleBeingUsedForScientificPurposesComputed: {
      get() {
        return this.agreedToSampleBeingUsedForScientificPurposes;
      },
      set(val) {
        return val;
      }
    },
    agreedToSampleExaminationComputed: {
      get() {
        return this.agreedToSampleExamination;
      },
      set(val) {
        return val;
      },
    },
    phone: {
      get() {
        return this.$store.state.viewCustomer.phone;
      },
      set(val) {
        return val;
      }
    },
    fields() {
      if (this.audit !== null && this.audit.length > 0) {
        const fields = Object.keys(this.audit[0]).map((x) => ({
          key: x,
          sortable: true,
          label: this.$t(`fields.${x}`)
        }));
        return fields;
      }
      return [];
    },
    audit() {
      const { audit } = this.$store.state.viewCustomer;
      const auditDisplay = audit.map((x) => ({
        ...x,
        changedAt: this.$moment(x.changedAt).format('DD.MM.YYYY HH:mm:ss'),
        field: this.$t(`fields.${x.field}`),
        oldValue: x.oldValue === 'false' || x.oldValue === 'true' ? this.$t(`common.${x.oldValue}`) : x.oldValue,
        newValue: x.newValue === 'false' || x.newValue === 'true' ? this.$t(`common.${x.newValue}`) : x.newValue
      }));
      return auditDisplay;
    }
  },
  created() {
    this.resetContext();
    this.setCustomerId(this.id);
    this.fetchCustomer();
    this.fetchAudit();
    this.fetchCategories()
      .then(() => {
        this.ready = true;
      });
  },
  watch: {
    audit() {
      this.totalRows = this.audit.length;
    }
  },
  methods: {
    ...mapActions({ fetchCustomer: 'viewCustomer/fetchCustomer',
      resetContext: 'viewCustomer/resetContext',
      fetchCategories: 'viewCustomer/fetchCategories',
      fetchAudit: 'viewCustomer/fetchAudit' }),
    ...mapMutations({ setCustomerId: 'viewCustomer/setCustomerId' }),
    downloadAddress() {
      this.axios.get('admin/samples/getaddresslabel', {
        params: {
          CustomerId: this.id
        },
        responseType: 'arraybuffer'
      }).then((response) => {
        downloadBlob(response.data, `Adresa ${this.name} ${this.surname}`, 'image/png');
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
